
import { Entity, FrameContext, BindingData } from '@farris/devkit';
import { BefRepository, BefRestService } from '@farris/bef';

/**
 * åºç¡æ°æ®æå¡
 */
class BaseDataService {

  /**
   * æ¡æ¶ä¸ä¸æ
   */
  protected frameContext: FrameContext;

  /**
   * å®ä½ä»åº
   */
  protected get repository(): BefRepository<Entity> {
    return this.frameContext.repository as BefRepository<Entity>;
  }

  /**
   * Restæå¡
   */
  protected get restService(): BefRestService {
    return this.repository.restService;
  }

  /**
   * æ°æ®ç»å®
   */
  protected get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  /**
   * æé å½æ°
   */
  constructor(frameContext: FrameContext) {
    this.frameContext = frameContext;
  }

}

export { BaseDataService };
